import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Route, Redirect } from 'react-router-dom';
import {
  selectIsFetching,
  selectIsAuthenticated,
  selectIsInitiated,
} from 'containers/Authentication/selectors';

class PrivateRoute extends PureComponent {
  render() {
    const {
      render: Component,
      isFetching,
      isAuthenticated,
      isInitiated,
      ...rest
    } = this.props;

    if (isAuthenticated) {
      return <Route {...rest} render={Component} />;
    }

    return (
      <Redirect
        to={{
          pathname: '/',
          state: { prevPath: this.props.location.pathname },
        }}
      />
    );
  }
}

PrivateRoute.propTypes = {
  component: PropTypes.func,
  isFetching: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  isFetching: selectIsFetching(),
  isAuthenticated: selectIsAuthenticated(),
  isInitiated: selectIsInitiated(),
});

export default connect(mapStateToProps)(PrivateRoute);
